
function boardFormDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/board-form/board-form-dialog.html?$$REVISION$$'
  }
}
export { boardFormDialog }
